import {ga} from "@/utils/adsense/ga";
import {gtag} from "@/utils/adsense/gtag";

export class AnalyticsHelper {


    static collectData({
                           pageKey,
                           featureName,
                           eventLabel,
                           event,
                       }: {
        pageKey: string;
        event: string;
        featureName: string;
        eventLabel: string;
    }) {
        ga("send", {
            hitType: "pageview",
            page: `/vp/${pageKey}/${event.toLowerCase()}/`,
            title: `${featureName} ${event}`,
        });

        gtag("event", event, {
            event_category: featureName,
            event_label: eventLabel,
        });
    };
}